<template>
           <div class="login">
    <header>
        <h1><i></i> 考核平台登录</h1>
    </header>
    <main>
        <div class="main">
            <div class="loginleft">

                <h2>
                    太原市互联网租赁自行车服务质量信誉考核信息管理平台
                </h2>
                <p>
                    欢迎登录
                </p>
                <p class="botten">{{newdata}}</p>
            </div>
            <div class="loginright">
                <h1>登录</h1>
                <div class="form">
                    <div class="username"><i></i><input type="text" name="username"  v-model="userName" placeholder="请输入用户名"></div>
                    <div class="password"><i></i><input type="password" name="password"  v-model="passWord"  placeholder="请输入密码"></div>
                    <!--<div class="code"><i style="margin: 16px 20px 12px 12px;"></i><input type="text" name="code" v-model="verifyCode" placeholder="请输入图形验证码">
                        <span id="v_container"></span>
                    </div>-->
                    <div class="checkbox">
                        <input type="checkbox" value="true" v-model="remember">记住我
                    </div>
                  <div class="button">
                    <button type="submit" @click="changeImgCode()">
                        登录
                    </button >
                </div>
                </div>
            </div>
        </div>
    </main>

</div>
</template>
<script>
 import { GVerify } from "../../assets/js/gVerify";
export default ({
    name:"Login",
    data(){
      return {
                newdata:'',
                userName:'',
                passWord:'',
              //  verificationCode:'',
                verifyCode: '',
                remember:false,
                verifyFlag: '',
                //verifyFlagimg:'/api/getVerificationCode'
            }

    },
     mounted () {
     	 localStorage.removeItem('is_demo')
     	 var url = window.location.href
     	 let qIndex = url.indexOf('?');
     	 let qtext = url.substring(qIndex + 1);
     	  if(qtext=='demo'){
     	  	this.userName = 'admin'
     	  	this.passWord = '123456'
     	  	this.changeImgCode()
     	  	localStorage.setItem('is_demo', true)
     	  }
            // 随机播放帧数

                this.verifyFlag = new GVerify('v_container')

                window.setInterval(() => {
                    this.getdata()
                }, 1000)
                
               

        },
        methods: {
            getdata(){
                var myDate = new Date();
                var year = myDate.getFullYear(); //获取当前年
                var mon = myDate.getMonth() + 1; //获取当前月
                var date = myDate.getDate(); //获取当前日
                var h = myDate.toLocaleTimeString();//获取当前小时数(0-23)前秒
                var week = myDate.getDay();
                var weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                this.newdata = year + "年" + mon + "月" + date + "日      " + weeks[week] +"      "+ h
            },

            // replace () {
            //   const num = Math.ceil(Math.random() * 10) // 生成一个随机数（防止缓存）
            //   this.verifyFlagimg = '/api/getVerificationCode?' + num
            // },
            changeImgCode() {
                var that = this;

                if(that.userName == ''){
                    this.$message.error('请输入用户名');
                    // alert("请输入用户名");
                    return false;
                };
                if(that.passWord == ''){
                    this.$message.error('请输入密码');
                    // alert("请输入密码");
                    return false;
                };
//              if(that.verifyCode == ''){
//                  this.$message.error('请输入图形验证码');
//                  // alert("");
//                  return false;
//              };
//            var verifyFlag = this.verifyFlag.validate(that.verifyCode);
//
//            if(!verifyFlag){
//              this.$message.error('验证码输入错误');
//              return false;
//            };
                var datas = {
                    userName:that.userName,
                    passWord:that.passWord,
                    remember:that.remember,
                    //verificationCode:that.verifyCode,
                };
                this.$axios.defaults.withCredentials = true;
                this.$axios
                    .post('/api/login', datas)
                    .then(function (res) {
                        if (res.data.code == 500) {
                            that.$message.error(res.data.msg);
                            return;
                        } else if (res.data.code == 200) {
                        	that.$store.state.meituan = '';
                            that.$message({
                                message: '登录成功',
                                type: 'success'
                                });
                                window.setTimeout(() => {
                                  that.$router.push('/admin/index')
                                   }, 1000);
                        }
                    }).catch(function (error) { // 请求失败处理
                    console.log("服务器错误"+error);
                });
            },
        }

})
</script>

<style scoped>
     @import '../../assets/css/alogin.css';
	#v_container{
		   width:80px;
		   height:30px!important;
		}

</style>



// WEBPACK FOOTER //
// src/view/admin/Login.vue